import {FC, useMemo} from 'react';
import dayjs from 'dayjs';
import {dateFormat} from '../../../../constants/constants';
import {ProcessDiagramIds} from '../../../../constants/tasks';
import {useTaskView} from '../context/task_view.context';

const TaskRowStart: FC = () => {
  const {processStartedAt} = useTaskView();

  const formattedStartAt = useMemo(() => {
    return dayjs(processStartedAt).format(dateFormat) || '';
  }, [processStartedAt]);

  return (
    <div className="task-row-elements_start">
      <div className="task-row-elements_start-circle" id={ProcessDiagramIds.START} />

      <p className="task-row-elements_start-time">{formattedStartAt}</p>
    </div>
  );
};

export default TaskRowStart;
